<template>
	<inertia-head title="Reset Password" />
	<form @submit.prevent="submit">
		<div class="form-floating mb-4">
			<input
				v-model="form.email"
				type="text"
				class="form-control"
				:class="{ 'is-invalid': form.errors.email }"
				id="email"
				placeholder="Enter your email"
			/>
			<label class="form-label" for="email">Email address</label>
			<div v-if="form.errors.email" class="invalid-feedback">
				<i class="fa fa-exclamation-circle"></i>
				{{ form.errors.email }}
			</div>
		</div>
		<div class="row g-sm">
			<div class="col-12 mb-2">
				<button
					type="submit"
					class="btn btn-lg btn-alt-primary w-100 py-3 fw-semibold"
					data-toggle="click-ripple"
					:disabled="form.processing"
				>
					<span v-if="!form.processing">Request New Password</span>
					<span v-else>
						<div class="spinner-border spinner-border-sm text-dark" role="status" >
							<span class="sr-only mr-1">Please wait...</span>
						</div>
						<span class="mx-2">Please wait...</span>
					</span>
				</button>
			</div>
		</div>
		<div v-if="!form.processing" class="row">
			<div class="col-sm-6 mb-1">
				<inertia-link
					:href="route('login')"
					class="btn btn-alt-secondary w-100"
				>
					Sign in
				</inertia-link>
			</div>
			<div class="col-sm-6 mb-1">
				<inertia-link
					:href="route('checkout.index', 'gold')"
					class="btn btn-alt-secondary w-100"
				>
					Create account
				</inertia-link>
			</div>
		</div>
	</form>
</template>

<script>
import { watch } from 'vue'
import { useForm } from '@inertiajs/inertia-vue3'
import GuestLayout from '../../Layouts/GuestLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: GuestLayout,
	setup() {
		const form = useForm({
			email: null,
		})

		const submit = () => {
			form.post(route('post.reset-password'), {
				only: ['errors', 'flash'],
			})
		}

		return {
			form,
			submit,
		}
	},
}
</script>
